<template>

  <el-container class="index-con">
    <el-header class="index-header" style="height: 50px">
      <!-- 头部菜单 -->
      <navcon :user="user"></navcon>
    </el-header>
    <el-container>
      <el-aside :class="showclass"  v-show="$route.path.indexOf('dashboard')<0">
        <!-- 左侧菜单 -->
        <leftnav></leftnav>
        <div :class="[ { 'buttom-aside':!collapsed },'buttom-menu']">
          <el-button :class="[ 'buttonimg']" @click="toggle(collapsed)">
            <svg t="1649943597699" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2937" width="25" height="25">
              <path d="M896 232.727273h-744.727273a34.909091 34.909091 0 0 1 0-69.818182h744.727273a34.909091 34.909091 0 0 1 0 69.818182zM896 884.363636h-744.727273a34.909091 34.909091 0 0 1 0-69.818181h744.727273a34.909091 34.909091 0 0 1 0 69.818181zM709.818182 558.545455h-558.545455a34.909091 34.909091 0 0 1 0-69.818182h558.545455a34.909091 34.909091 0 0 1 0 69.818182z" p-id="2938" fill="#515151"></path>
            </svg>
          </el-button>
        </div>

      </el-aside>
      <el-main clss="index-main">
        <router-view></router-view>
        <wxscanCompnent :visibleC="wxscan.dialogVisible" :userid="user.id" @closeDialog="closeDialog"></wxscanCompnent>
        
        <clueDialogCompnent :visibleC="clue.dialogVisible" :id="clue.productId" @closeDialog="closeClueDialog"></clueDialogCompnent>
      </el-main>
    </el-container>
  </el-container>

</template>
<script>
// 导入组件
import navcon from '../components/navcon.vue'
import leftnav from '../components/leftnav.vue'
import wxscanCompnent from '../components/scan/wxscan.vue'
import clueDialogCompnent from '../components/clue/clueDialog.vue'
//实体类
import { User} from '../module/entity' 
//接口
import{user} from '../api/userMG'

export default {
  name: 'index',
  data() {
    return {
      showclass: 'asideshow',
      collapsed: false,
      leftMenuShow: true,
      user: new User,
      clue: {
        dialogVisible: false,
        productId: null
      },
      wxscan:{
        dialogVisible: false
      }
    }
  },
  // 注册组件
  components: {
    navcon,
    leftnav,
    wxscanCompnent,
    clueDialogCompnent
  },
  methods: {
    // 切换显示
    toggle(showtype) {
      this.collapsed = !showtype
      this.$root.Bus.$emit('toggle', this.collapsed)
    },
    
    // 关闭扫码弹框
    closeDialog(data) {
      this.user.bindWeiChat = data.bind
      this.$store.commit('login', this.user)
      this.wxscan.dialogVisible = !this.user.bindWeiChat
    },
    
    // 关闭免费试用申请弹框
    closeClueDialog(data) {
      this.clue.dialogVisible = data
      this.$cookies.remove('H-pid')
    },
  },
  created() {
    // 监听
    this.$root.Bus.$on('toggle', value => {
      if (value) {
        this.showclass = 'asideshow'
      } else {
        setTimeout(() => {
          this.showclass = 'aside'
        }, 300)
      }
    })

    const productId = this.$cookies.get('H-pid')
    if(productId){
      this.clue.dialogVisible = true
      this.clue.productId = Number(productId)
    }

    //获取个人信息
    user('me').then(res=>{
      if(res.code==0){
        this.$store.commit('login', res.data)
        this.user = res.data
        if(!this.clue.productId){
          this.wxscan.dialogVisible = !this.user.bindWeiChat
        }
        
      }
    })

  },
  mounted() {
    this.toggle(this.collapsed)

    // console.log('path====>'+this.$route.path)
    if(this.$route.path.indexOf('dashboard')>-1){
      this.leftMenuShow = false
    }else{
      this.leftMenuShow = true
    }

  },
  beforeUpdate() {},
  // 挂载前状态(里面是操作)
  beforeMount() {
   
  }
}
</script>


<style >
.index-con {
  height: 100%;
  width: 100%;
  box-sizing: border-box;
}

.aside {
  width: 50px !important;
  /* height: 100%; */
  
  height: auto;
  background-color: #fff;
  margin: 0px;
  /* box-shadow: 2px 2px 10px #e9e9e9;
  border-left: 2px solid #333; */
}
.asideshow {
  width: 200px !important;
  /* height: 100%; */
  height: auto;
  background-color: #fff;
  margin: 0px;

  /* box-shadow: 2px 2px 10px #e9e9e9;
  border-left: 2px solid #333; */
}
.index-header,
.index-main {
  padding: 0px;
  /* border-left: 2px solid #333;
  box-shadow: 2px 2px 10px #e9e9e9; */
}
.el-container {
  border-top: 1px solid #e9e9e9;
}
.buttom-menu {
  border-top: 1px solid #dcdfe6;
  width: 200px;
  /* position: absolute; */
  position: fixed;
  bottom: 0px;
  height: 50px;
}
.buttonimg {
  position: relative;
  border: 0px;
  border-radius: 0px;
  height: 50px;
  width: 100%;
  text-align: left;
}
.buttom-menu .el-button:hover {
  background-color: #ffefec;
  /* border-left: 3px solid #c92310; */
}

.buttom-menu:hover {
  background-color: #ffefec;
  /* border-left: 3px solid #c92310; */
}
.buttom-aside{
  width: 50px !important;
}
</style>



// WEBPACK FOOTER //
// src/views/index.vue